module.exports = __webpack_public_path__ + "img/icon_dialog_qq_hover.0ba0d514.png";